import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Economisești {{percentageAmount}}% la articolele selectate',
    description:
      'Economisești {{percentageAmount}}% la comandă când alegi articolele selectate. Oferta este valabilă{{fromTo}} până la atingerea limitei maxime de promoții, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% reducere de la {{minSpendValue}}',
    description:
      'Economisești {{percentageAmount}}% la comandă. Oferta este valabilă{{fromTo}} până la atingerea limitei maxime de promoții, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Economisești {{amount}} la articolele selectate',
    description:
      'Economisești {{amount}} când alegi articolele selectate. Oferta este valabilă{{fromTo}} până la atingerea limitei maxime de promoții, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Economisești {{amount}} de la {{minSpendValue}}',
    description:
      'Economisești {{amount}} la o valoare a comenzii. Oferta este valabilă{{fromTo}} până la atingerea limitei maxime de promoții, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Cumpără 2 la prețul de 1!',
    description:
      'Cumpără un articol și primești al doilea gratuit. Oferta este valabilă{{fromTo}} până la atingerea limitei promoționale, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Cumpără unul, al doilea la jumătate de preț!',
    description:
      'Cumpără un articol și primești al doilea la jumătate de preț. Oferta este valabilă{{fromTo}} până la atingerea limitei promoționale, oricare survine prima. Nu poate fi combinată cu alte promoții.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Articol gratuit la o valoare a comenzii',
    description:
      'Primești un articol gratuit când îndeplinești condițiile ofertei. Oferta este valabilă{{fromTo}} până la atingerea limitei promoționale, oricare survine prima. Nu poate fi combinată cu alte promoții.',
    reward_items_description: 'Alege articolul tău gratuit.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Articol gratuit la comandă',
    description:
      'Primești un articol gratuit când îndeplinești condițiile ofertei. Oferta este valabilă{{fromTo}} până la atingerea limitei promoționale, oricare survine prima. Nu poate fi combinată cu alte promoții.',
    qualifying_items_description:
      'Selectează articolele pe care clientul trebuie să le comande pentru a primi articolul gratuit.',
    reward_items_description: 'Alege articolul tău gratuit.',
  },
};

export default {
  offers,
  from_to: ' de la {{startsAt}} până la {{endsAt}} sau',
  qualifying_items_title: 'Articole eligibile',
  reward_items_title: 'Articole gratuite',
  buttons: {
    add: 'Adaugă în coș',
  },
};
